import React from 'react'
import inputComponents from './inputComponents'
import { checkConditionGroup, checkTextTranslation, checkTranslation, getObject, setObject, translate } from '../../utils/useful'
import ActionsBtn from '../partials/ActionsBtn'
import { nanoid } from 'nanoid'
import Modal from '../Modal'
import FormViewer from '../FormViewer'
import ButtonAnimated from '../buttons/ButtonAnimated'
import HelpButton from '../HelpButton'
import ObjectID from 'bson-objectid'

class SubformInput extends React.Component {
    state = {
        errors: {},
        data: {},
        indexKey: nanoid(),
        // actions: {
        //     // edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: '/assets/icons/imports/edit.svg' },
        //     remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', borderTop: '1px solid #eee', icon: '/assets/icons/imports/trash.svg', function: "openRemoveModal" },
        // },
        width: window.innerWidth
    }

    componentDidMount() {
        this.init()
        window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {


        if ((this.props.initData !== prevProps.initData) || (this.props.headers !== prevProps.headers)) {

            this.init()
        }
    }

    getForm = () => {
        // console.log(this.validator())
        if (this.validator()) {
            return this.state.data ? this.state.data : {}
        } else {
            return null
        }
    }



    init = () => {

        let actions = {
            // edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: '/assets/icons/imports/edit.svg' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', borderTop: '1px solid #eee', icon: '/assets/icons/imports/trash.svg', function: "removeRow" },
        }

        if (this.props.header.information?.removeDisabled) {
            actions = null
        }
        this.setState({ actions })

        this.makeInitValue(this.props.initData)
    }


    validator() {
        let valid = true
        let errors = {}
        this.props.headers.forEach(header => {
            if (header.information?.required) {

                let value = getObject(this.state.data, header.key)

                if (header.type == 'ImageInput' || header.type == 'FileInput') {

                    if (!value || value === '') {
                        value = getObject(this.state.data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
                if (header.type == 'PhoneInput') {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value.length < 14) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
            }
        })

        this.setState({ errors })
        return valid
    }

    makeInitValue(rowData) {

        let data = rowData
        if (data == null) {
            data = {}
        }
        if (this.props.headers) {

            this.props.headers.forEach(header => {
                if (data[header.key] == null && header.information?.default != null) {
                    data[header.key] = header.information?.default
                }
            });
        }

        this.setState({ data: data, show: true }, () => {
            this.setFormWidth()
            if (!this.props.data && this.props.header?.information?.defaultRow) {
                this.addNew()
            }
        })

    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width })
        }
    }


    actionClicked = (prop, data, index) => {
        let name = prop?.function
        if (this[name]) {
            this[name](data, index)
        }
        // console.log("Action Clicked", prop, data, index)
    }




    addNew = () => {
        let data = this.props.data
        if (!Array.isArray(data)) {
            data = []
        }

        let newObject = { _id: ObjectID() }

        this.props.header.information?.headers?.forEach(header => {
            if (header.information?.default) {
                newObject[header.key] = header.information?.default
            }
        });




        data.push(newObject)
        this.props.changeValue(this.props.header.key, data, this.props.extra)

        this.openFormModal(newObject, data.length - 1)


    }

    removeRow = (info, index) => {
        let data = this.props.data
        // if (!Array.isArray(data)) {
        //     data = []
        // }
        // data.push({})
        data.splice(index, 1)
        this.props.changeValue(this.props.header.key, data, this.props.extra)
    }


    changeFiles = (files, key, extra) => {
        // let data = this.state.data ?? {}

        // if (data['**files'] == null) {
        //     data['**files'] = {}
        // }
        // value.formType = ''

        // this.props.header.information.headers.forEach(header => {
        //     if (header.key == key) {
        //         value.formType = header.type
        //         // value.single = header.information?.single
        //     }
        // });

        // data['**files'][key] = value
        // console.log(data)
        // this.setState({ data })
        // console.log(extra)
        // console.log(files)

        this.props.changeValue('**files', { [this.props.header.key + '.' + extra?.index + "~" + key]: files }, { append: 'object' }, this.props.extra)
        // this.props.changeValue('**files.' + this.props.header.key + '.' + extra?.index + "~" + key, files)

        // this.props.changeValue('**files', { [this.props.header.key+'!!' + '.' + key ]: files })

    }


    changeValue = (key, value, extra) => {


        let data = this.props.data
        let index = extra ? extra[this.state.indexKey] : 0


        if (Array.isArray(data)) {
            data = setObject(data, key, value, false, index)
            this.props.changeValue(this.props.header.key, data, this.props.extra)
        }
    }



    formColBuilder(col) {
        let finalCol = 'col-12'

        // if (100 < this.state.width && col) {
        finalCol = 'col-' + col
        // }

        return finalCol
    }

    renderHeader(headers) {
        if (headers) {
            return (headers.map((header, index) => {
                if (header.showMain != false) {
                    return (
                        <div key={index} className={" mb-1 form-label d-flex p-0  text-semibold pt-2 flex-column justify-content-end " + this.formColBuilder(header.col)} >
                            <div className='flexc'>
                                <label className={'text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
                                {header.information?.help && (
                                    <HelpButton data={header.information?.help} />
                                )}
                            </div>
                            {header.information?.hint && (
                                <div className="mx-1 text-start text-smallest">
                                    <div style={{ color: '#9ab', fontWeight: '500' }}>{checkTextTranslation(header.information?.hint)}</div>
                                </div>
                            )}
                        </div>
                    )
                }
            }))
        }
    }



    findComponentSwitcher(states, variables) {

        let header
        for (let i = 0; i < states.length; i++) {
            const element = states[i];
            // console.log(element)

            if (Array.isArray(element.conditions)) {
                for (let j = 0; j < element.conditions.length; j++) {

                    const condition = element.conditions[j];

                    let result = checkConditionGroup(condition.root, variables)

                    if (result) {
                        header = element.header
                    }

                    // console.log(result)


                }
            }

        }

        return header
    }


    openFormModal = (data, index) => {
        if (this.props.header?.information?.modalMode) {
            this.setState({ currentRow: data, currentIndex: index })
            this.formModal.showModal()
        }
    }


    renderBody(headers, rowData, index) {
        return (
            // <div className="flexcc p-1">

            // {
            headers && headers.map((mheader, hindex) => {

                let header = { ...mheader }

                if (header.type == "componentSwitcher") {
                    header = this.findComponentSwitcher(mheader.states, { data: rowData }) ?? {}
                }

                if (mheader.showMain == false) {
                    return
                }


                let Component = inputComponents[header.type]


                // console.log(rowData)
                let data = getObject(rowData, header.key)//data[header.key] ? data[header.key] : ''
                let files
                if (rowData && rowData['**files']) {
                    files = getObject(rowData['**files'], header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                }

                if (data == null && header.information?.default != null) {
                    data = header.information?.default
                }

                let extra = this.props.extra ? { ...this.props.extra } : {}
                extra[this.state.indexKey] = index
                extra['index'] = index

                // console.log(extra)
                if (Component) {
                    return (
                        <div key={hindex} className={" mb-0 p-0 " + this.formColBuilder(header.col)} >

                            <div className={"w-100 prd-2 "} >



                                <div className="w-100 p-0 mb-2">
                                    <div className={"flexc " + (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : 'default-subinput-view'))} >
                                        {header.information?.icon && (
                                            <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
                                        )}
                                        <Component extra={extra} fullData={this.props.fullData} rowData={rowData} header={header} data={data} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} variables={this.props.variables} optionsList={this.props.optionsList} inplaceView={true} inputClass={this.props.inputClass} setFetchedData={this.props.setFetchedData} fetchedData={this.props.fetchedData?.[header?.key]} />
                                    </div>
                                </div>



                                {this.props.errors && this.props.errors[header.key] && (
                                    <div className="col-12 mt-1 mld-2 text-start">
                                        <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
                                    </div>
                                )}

                                {this.state.errors && this.state.errors[header.key] && (
                                    <div className="col-12 mt-1 mld-2 text-start">
                                        <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
                                    </div>
                                )}

                            </div>
                        </div>
                    )
                }
            })
            //     }
            // </div>

        )
    }

    submitRow = () => {
        let data = this.props.data
        let index = this.state.currentIndex
        if (this.modalForm) {
            let form = this.modalForm.getForm()

            // console.log(form)
            // console.log(index)

            if (Array.isArray(data) && form) {
                data[index] = form
                this.props.changeValue(this.props.header.key, data, this.props.extra)
                this.formModal.hideModal()
            }
        }
    }



    render() {
        let headers = this.props.header.information?.headers
        // console.log(this.props.data)



        if (this.state.show) {
            return (
                <section className="w-100 subform  col-12 px-0" ref={(el) => this.form = el} style={{ borderTop: '0px solid #eee', borderBottom: '0px solid #eee' }}>

                    {this.props.inplaceView ? (
                        <>
                            <div className='  w-100 h-100 cursor-pointer' onClick={() => this.modal.showModal()}>
                                <button className=' w-100 h-100 text-start'  >

                                    {(Array.isArray(this.props.data) && this.props.data.length > 0) ? (
                                        <p className=" w-100 h-100 text-start"> {translate("{{rows}} Rows", { rows: this.props.data.length })}</p>
                                    ) : (
                                        <p className="placeholder w-100 h-100 text-start"> {this.props.information?.placeholder ?? translate('Value ...')}</p>
                                    )}

                                </button>
                            </div>

                            <Modal ref={el => this.modal = el} maxWidth={600}>
                                <div className="flexcc flex-column p-3 bg-white br-15" >
                                    <SubformInput header={this.props.header} data={this.props.data} fullData={this.props.fullData} rowData={this.props.rowData} changeValue={this.props.changeValue} extra={this.props.extra} variables={this.props.variables} params={this.props.params} inputClass={this.props.inputClass} />
                                </div>
                            </Modal>
                        </>
                    ) : (
                        <>

                            <div className={"w-100"} style={{ overflow: 'auto' }}>

                                <div className="flexc w-100 mb-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
                                    {/* {!this.props.header.information?.removeDisabled && (
                                <button className="flexcc p-1">
                                    <img src="/images/remove.png" width="18px" style={{ opacity: 0 }} />
                                </button>
                            )} */}
                                    {this.state.actions && (
                                        <div ref={el => this[''] = el} className={"flexcc mrd-2"} style={{ flex: '0 0', maxWidth: 20, flexBasis: 20, borderRight: "none", borderLeft: "none", width: 20 }}>
                                            <img className='stage-action-button-img opacity-2' src={'/assets/icons/useful/action.png'} height={10} />
                                        </div>
                                    )}
                                    <div className="row m-0 mb-1 w-100" style={{ flexWrap: 'nowrap' }}>
                                        {this.renderHeader(headers)}
                                    </div>
                                </div>


                                {Array.isArray(this.props.data) && this.props.data?.map((prop, index) => {
                                    return (
                                        <div className="flexc w-100 position-relative" key={index}>
                                            {/* {(!this.props.header.information?.removeDisabled) && (
                                        <>
                                            {!prop['**notRemoveable'] && (
                                                <button onClick={() => this.removeRow(index)} className="flexcc p-1 position-absolute  " style={{ zIndex: 0, top: 5, right: -18 }} >
                                                    <img src="/images/remove.png" width="16px" />
                                                </button>
                                            )}

                                           
                                        </>
                                    )} */}

                                            {this.state.actions && (
                                                <div className='mrd-2  flexcc' style={{}}>
                                                    <ActionsBtn index={index} actions={this.state.actions} actionClicked={this.actionClicked} currentRecord={this.props.currentRecord} colors={this.props.colors} />
                                                </div>
                                            )}

                                            <div className={'w-100 ' + (this.props.header?.information?.modalMode ? 'cursor-pointer' : '')} onClick={() => this.openFormModal(prop, index)}>
                                                <div key={index} className={"row m-0 w-100 "} style={{ flexWrap: 'nowrap', pointerEvents: this.props.header?.information?.modalMode ? 'none' : null }} >

                                                    {this.renderBody(headers, prop, index)}

                                                </div>

                                            </div>
                                        </div>

                                    )
                                })}
                            </div>


                            <div className={"flexc  mt-1 mb-3 " + (this.state.actions ? "px-2" : '')}>

                                {!this.props.header.information?.addDisabled && (

                                    <button onClick={() => this.addNew()} className=" py-1 mld-2 mrd-3" style={{ color: '#007aff', borderRadius: 4 }}>
                                        <p className=" text-small  text-semibold">+ {translate("Add new option")}</p>
                                    </button>

                                )}

                                {(!Array.isArray(this.props.data) || this.props.data.length == 0) && (
                                    <div className='flexc   mt-0 '>
                                        <div className='' style={{ borderRadius: 6, padding: '6px 0px', color: "#777" }}>
                                            <p className="text-small text-semibold">{translate('No row is added')}</p>
                                        </div>
                                    </div>
                                )}

                            </div>
                            {this.props.errors && (typeof this.props.errors == 'string') && (
                                <div className="col-12 text-start">
                                    <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors)}</small>
                                </div>
                            )}

                        </>
                    )
                    }



                    <Modal ref={el => this.formModal = el} maxWidth={600}>
                        <div className="flexcc flex-column  bg-white br-15" >

                            <div className='w-100 flexcb mb-2 px-4 pt-2 pb-2' style={{ borderBottom: '1px solid #eee', }}>
                                <p className='text-bold text-normal'>{checkTranslation(this.props.header?.information?.label)}</p>

                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { !this.state.isLoading && this.submitRow() }}
                                    title={translate('Submit')}
                                    // icon='/assets/icons/plus-white.svg'
                                    textColor={'#fff'}
                                    // invert={!this.props.colors?.iconInvert}
                                    bg={'#007aff'}
                                    isLoading={this.state.isLoading}
                                />

                            </div>
                            <div className='pb-2 px-1 mb-4 w-100'>
                                <FormViewer ref={el => this.modalForm = el} headers={headers} initData={this.state.currentRow} changeValue={this.props.changeValue} variables={this.props.variables} params={this.props.params} width={this.props.width} formClass="modern" inputClass={'modern-input'} col={12} />

                                <div className='px-3 flexcb'>

                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.formModal.hideModal() }}
                                        title={translate('Cancel')}
                                        // icon='/assets/icons/plus-white.svg'
                                        textColor={'#777'}
                                        // invert={!this.props.colors?.iconInvert}
                                        bg={'#eee'}
                                        isLoading={this.state.isLoading}
                                    />


                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { !this.state.isLoading && this.submitRow() }}
                                        title={translate('Submit')}
                                        // icon='/assets/icons/plus-white.svg'
                                        textColor={'#fff'}
                                        // invert={!this.props.colors?.iconInvert}
                                        bg={'#007aff'}
                                        isLoading={this.state.isLoading}
                                    />



                                </div>
                            </div>
                        </div>
                    </Modal>


                </section >
            )
        } else {
            return (<div></div>)
        }
    }
}

export default SubformInput;